import { createSlice } from "@reduxjs/toolkit";
import { fetchWorkflow, updateWorkflowInfo } from "api/formDisplay";
import { traverseAndFlatten } from "helper/destructureObject";

const initialState = {
  selectedData: {},
  formGeneratorData: {},
  formGenerator: [],
  selectedQuestion: {},
  isToggled: false,
  copiedData: {},
  questionData: [],
  questionnaireId: "",
  assetsKeyValue: {},
  netAssetsKeyValue: {},
  finalAssetsNetValue: {},
  totalNetValue: {},
  calculatedValue: 0,
  financialDetails: {},
  countryCode: {},
  restricted_view: false,
  userInfoUpdatedSuccessfully: false,
  isValidateTriggered: false,
  radioFields: {},
  toggleFields: {},
  mandatoryExtraction: {},
  evaluationRule: "",
  isPaymentInProgess: false,
  isErrorInPaymentInitiation: false,
  paymentDetails: {},
  bulkaddCustomer: [],
  isDuplicateFormInput: {},
  bulkaddWorkflow:[]
};

function flatten(obj) {
  var flattenedObject = {};
  traverseAndFlatten(obj, flattenedObject);
  return flattenedObject;
}

export const formDisplay = createSlice({
  name: "formDisplay",
  initialState,
  reducers: {
    setTotalNetValue: (state, action) => {
      state.totalNetValue[action.payload.fieldName] = action.payload.fieldValue;
    },
    setFinancialDetails: (state, action) => {
      state.financialDetails[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    setTotalNetAssestsValue: (state, action) => {
      state.finalAssetsNetValue[action.payload.fieldName] = action.payload.fieldValue;
    },
    addValueToNetAssets: (state, action) => {
      state.netAssetsKeyValue[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    addValueToAssets: (state, action) => {
      state.assetsKeyValue[action.payload.fieldName] =
        action.payload.fieldValue;
    },
    setCalculatedValue: (state, action) => {
      state.calculatedValue = action.payload;
    },
    setSelectedData: (state, action) => {
      if (action.payload.key) {
        state.selectedData = {
          ...state.selectedData,
          [action.payload.key]: action.payload.value,
        };
      }
    },
    assignValueToKey: (state, action) => {
      state.selectedData[action.payload.key] = action.payload.value;
    },
    setFormGeneratorData: (state, action) => {
      // console.log("inside form generator", action.payload)
      if (action.payload) {
        state.formGeneratorData = {
          type: action.payload.type,
          label: action.payload.label,
          name: action.payload.name,
          is_required: action.payload.is_required,
        };
      }
    },
    setFormGenerator: (state, action) => {
      state.formGenerator = [...state.formGenerator, action.payload];
    },
    clearSelectedDataKey: (state, action) => {
      state.selectedData = {
        ...state.selectedData,
      };
      delete state.selectedData[action.payload.key];
    },
    clearSelectedData: (state, action) => {
      state.selectedData = {};
    },
    setSelectedQuestion: (state, action) => {
      state.selectedQuestion = {
        ...state.selectedQuestion,
        [action.payload.key]: action.payload.value,
      };
    },
    setQuestionData: (state, action) => {
      state.questionData = [...state.questionData, action.payload];
    },
    setUpdateQuestionData: (state, action) => {
      state.questionData = [...action.payload];
    },
    setIsToggled: (state, action) => {
      state.isToggled = action.payload;
    },
    setCopiedData: (state, action) => {
      state.copiedData = {
        ...state.copiedData,
        [action.payload.key]: action.payload.value,
      };
    },
    setbulkaddCustomer: (state, action) => {
      state.bulkaddCustomer = action.payload;
    },
    clearCopiedData: (state, action) => {
      state.copiedData = {};
    },
    clearbulkaddCustomer: (state, action) => {
      state.bulkaddCustomer = [];
    },

    setQuestionnaireId: (state, action) => {
      state.questionnaireId = action.payload;
    },
    setCountryCode: (state, action) => {
      state.countryCode = action.payload;
    },
    setRestrictedView: (state, action) => {
      state.restricted_view = action.payload;
    },
    setValidateTriggered: (state, action) => {
      state.isValidateTriggered = action.payload;
    },
    clearValidateTriggered: (state, action) => {
      state.isValidateTriggered = false;
    },
    fetchSelectedFormData: (state, action) => {
      state.selectedData = { ...action.payload }
    },
    updateSelectedFormData: (state, action) => {
      state.selectedData = { ...state.selectedData, ...action.payload }
    },
    setRadioFields: (state, action) => {
      state.radioFields = {
        ...state.radioFields,
        [action.payload.key]: action.payload.value
      }
    },
    setToggleFields: (state, action) => {
      state.toggleFields = {
        ...state.toggleFields,
        [action.payload.key]: action.payload.value
      }
    },
    setMandatoryExtraction: (state, action) => {
      state.mandatoryExtraction = {
        ...state.mandatoryExtraction,
        [action.payload.key]: action.payload.value
      }
    },
    setEvaluationRule: (state, action) => {
      state.evaluationRule = action.payload
    },
    setIsPaymentInProgess: (state, action) => {
      state.isPaymentInProgess = action.payload
    },
    resetIsPaymentInProgess: (state, action) => {
      state.isPaymentInProgess = false
    },
    setIsPaymentInitiationError: (state, action) => {
      state.isErrorInPaymentInitiation = action.payload
    },
    clearSpecificFields(state, action) {
      const keysToBeCleared = action?.payload;
      for(let keyName of keysToBeCleared) {
        state.selectedData[keyName] = "";
      }
    },
    setIsDuplicateFormInput: (state, action) => {
      state.isDuplicateFormInput = { ...state.isDuplicateFormInput, ...action.payload };
    },
    setbulkaddWorkflow: (state, action) => {
      state.bulkaddWorkflow = action.payload;
    },
    clearbulkaddWorkflow: (state, action) => {
      state.bulkaddWorkflow = [];
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkflow.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        let formattedData = action.payload;
        const { uploadedDocument } = formattedData;

        const { source_data } = action.payload;
        if (source_data) {
          delete formattedData.source_data;
        }

        if (uploadedDocument) {
          delete formattedData.uploadedDocument;
        }
        state.selectedData = { ...formattedData, ...source_data };
        state.error = "success";
      })
      .addCase(fetchWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = "rejected";
      });
    builder
      .addCase(updateWorkflowInfo.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateWorkflowInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfoUpdatedSuccessfully = true;
      })
      .addCase(updateWorkflowInfo.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelectedData,
  clearSelectedData,
  clearSelectedDataKey,
  setSelectedQuestion,
  setIsToggled,
  setCopiedData,
  setbulkaddCustomer,
  clearCopiedData,
  clearbulkaddCustomer,
  setQuestionData,
  setUpdateQuestionData,
  setQuestionnaireId,
  setTotalNetAssestsValue,
  addValueToNetAssets,
  addValueToAssets,
  setTotalNetValue,
  setCalculatedValue,
  setFinancialDetails,
  setCountryCode,
  setRestrictedView,
  setFormGenerator,
  setFormGeneratorData,
  setValidateTriggered,
  clearValidateTriggered,
  fetchSelectedFormData,
  updateSelectedFormData,
  assignValueToKey,
  setRadioFields,
  setToggleFields,
  setMandatoryExtraction,
  setEvaluationRule,
  setIsPaymentInitiationError,
  resetIsPaymentInProgess,
  setIsPaymentInProgess,
  clearSpecificFields,
  setIsDuplicateFormInput,
  setbulkaddWorkflow,
  clearbulkaddWorkflow
  
} = formDisplay.actions;

export default formDisplay.reducer;
